/**
 * serverClock — "what time does the SERVER think it is?"
 *
 * WHY NOT JUST USE Date.now()
 * ---------------------------
 * Checkout tells the student which evening their order arrives on, and that
 * answer flips at the college's cutoff — 4 PM by default. A phone whose clock
 * is wrong by a few hours (or set to the wrong timezone, or simply never
 * synced) would be told the wrong DAY, and would then be surprised when the
 * order did not turn up. The delivery batch is decided by the server's clock,
 * so the page should describe the server's clock.
 *
 * HOW
 * ---
 * Every HTTP response already carries a `Date` header, so the correction is
 * free — no extra request, no time API. We keep the difference between it and
 * the device clock and add that back whenever someone asks the time. Until the
 * first response lands the offset is 0, which is simply today's behaviour.
 *
 * Accuracy is roughly "within a second", which is far more than enough for a
 * question whose answer only changes once a day.
 */

let offsetMs = 0;
let synced = false;

/**
 * Records the server's time from a response's `Date` header.
 * Ignores anything unparseable rather than corrupting the offset.
 *
 * @param {string | undefined} dateHeader
 */
export function syncFromDateHeader(dateHeader) {
  if (!dateHeader) return;
  const serverMs = Date.parse(dateHeader);
  if (Number.isNaN(serverMs)) return;
  offsetMs = serverMs - Date.now();
  synced = true;
}

/** The current time in milliseconds, corrected towards the server's clock. */
export function serverNow() {
  return Date.now() + offsetMs;
}

/** Whether a real server time has been seen yet (the device clock is in use if not). */
export function isClockSynced() {
  return synced;
}
